import _ from 'lodash';

export const normalizeValidationFieldPath = (field = "") => String(field).replace(/\[\d+\]/g, '[]');

export const buildValidationFieldOrderForWizard = ({
    fields = [],
    wizard,
    matchesWizard = () => true,
} = {}) => {
    const orderedFields = [];
    const seen = new Set();

    (Array.isArray(fields) ? fields : []).forEach((fieldDefinition) => {
        if (!fieldDefinition?.field || !matchesWizard(fieldDefinition?.wizard, wizard)) {
            return;
        }

        const normalizedField = normalizeValidationFieldPath(fieldDefinition.field);
        if (!seen.has(normalizedField)) {
            seen.add(normalizedField);
            orderedFields.push(normalizedField);
        }
    });

    return orderedFields;
};

export const addFieldError = (fieldErrors, field, message) => {
    if (!field || !message) {
        return;
    }

    const normalizedField = normalizeValidationFieldPath(field);
    if (!fieldErrors.has(normalizedField)) {
        fieldErrors.set(normalizedField, message);
    }
};

export const appendValidationContext = (message = "", context = "") => {
    const normalizedMessage = String(message || "").trim().replace(/[.?!:;,]+$/, "");
    const normalizedContext = String(context || "").trim();

    if (!normalizedContext) {
        return normalizedMessage;
    }

    return `${normalizedMessage} for ${normalizedContext}`;
};

export const getFirstOrderedValidationMessage = ({
    orderedFields = [],
    fieldErrors,
    generalErrors = [],
} = {}) => {
    for (const field of orderedFields) {
        const message = fieldErrors.get(field);
        if (message) {
            return message;
        }
    }

    const firstFieldError = fieldErrors.values().next();
    if (!firstFieldError.done) {
        return firstFieldError.value;
    }

    return generalErrors[0] || "";
};

export const getFirstOrderedMappedErrorMessage = (orderedFields = [], errorMap = {}) => {
    for (const fieldPath of orderedFields) {
        const fieldError = Object.prototype.hasOwnProperty.call(errorMap || {}, fieldPath)
            ? errorMap[fieldPath]
            : _.get(errorMap, fieldPath);
        if (fieldError) {
            return fieldError;
        }
    }

    return Object.values(errorMap || {}).find(Boolean) || null;
};
